import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  return <section data-section-id="23913" id="studio-reach" className="dark bg-background py-16 text-foreground">
      <div className="mx-auto max-w-7xl px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {}
          <div>
            <h3 className="mb-4 font-sans text-lg font-bold uppercase tracking-widest text-foreground">
              Site Map
            </h3>
            <div className="flex flex-col gap-2">
              <Link to="#" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">
                Work
              </Link>
              <Link to="#" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">
                Services
              </Link>
              <Link to="#" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">
                About
                
              </Link>
            </div>
          </div>

          {}
          <div>
            <h3 className="mb-4 font-sans text-lg font-bold uppercase tracking-widest text-foreground">
              Social
            </h3>
            <nav className="flex flex-col gap-2">
              <Link to="#" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">YOUTUBE</Link>
              <Link to="#" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">Linkedin</Link>
              <Link to="/home/general-terms-and-conditions" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">GENEREL TERMS</Link>
              
              <Link to="/home/privacy-policy" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">Privacy policy</Link>
            </nav>
          </div>

          {}
          <div>
            <h3 className="mb-4 font-sans text-lg font-bold uppercase tracking-widest text-foreground">
              Contact
            </h3>
            <nav className="flex flex-col gap-2">
              <div className="flex items-start gap-2">
                <span className="mt-1.5 size-1.5 shrink-0 rounded-none bg-primary" />
                <Link to="mailto:info@fanava.studio" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">info@fanava.studio</Link>
              </div>
              <div className="flex items-start gap-2">
                <span className="mt-1.5 size-1.5 shrink-0 rounded-none bg-primary" />
                <Link to="tel:+23054884551" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">+230 54 884 551</Link>
              </div>
              <div className="flex items-start gap-2">
                <span className="mt-1.5 size-1.5 shrink-0 rounded-none bg-primary" />
                <p className="text-base uppercase tracking-wider text-foreground">GRand BAIE, Mauritius</p>
              </div>
              <div className="flex items-start gap-2">
                <span className="mt-1.5 size-1.5 shrink-0 rounded-none bg-primary" />
                <Link to="#" className="text-base uppercase tracking-wider text-foreground transition-colors duration-400 ease-in-out hover:text-primary">
                  Careers
                </Link>
              </div>
            </nav>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        <div className="flex flex-col items-center justify-center gap-4 text-center text-sm uppercase tracking-widest text-muted-foreground md:flex-row">
          <span className="font-bold text-foreground">FanaVa</span>
          <span className="hidden md:block">|</span>
          <span>Copyright © 2026 FanaVa</span>
        </div>
      </div>
    </section>;
}